import { DocumentReportQueries } from "store/types";

export enum DocumentSectionType {
  Text = "text",
  Question = "questions",
  AIQuestion = "ai_questions",
  Image = "image",
  File = "file",
  AIFile = "ai_file",
  RichText = "rich_text",
  KPI = "kpi",
  Graph = "graph",
  Table = "table",
  Meeting = "meeting",
  WebSearch = "web_search",
  CashflowGraph = "cashflow_graph",
  AnalyzeFundTable = "analyze_fund_table"
}

export enum DocumentSectionSharedUserType {
  Viewer = "viewer",
  Guest = "guest"
}

export enum DocumentSectionSharedUserStatus {
  Waiting = "waiting",
  Approved = "approved"
}

export enum DocumentAnswerState {
  Draft = "draft",
  Published = "published"
}

export const defaultDocumentReportQueries: DocumentReportQueries = {
  dateRange: { value: "today" },
  currency: "USD",
  filters: {},
  exchangeMethod: "toDate"
};

export const DOCUMENTS_PANE_MIN_WIDTH_PX = 300;
export const DOCUMENTS_PANE_MAX_WIDTH_PX = 600;
